import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sends a virtual page_view to GA4 / GTM on every client-side route change.
 * Mounted once near the top of the app tree.
 */
export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "spa_pageview",
        page_path: path,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);

  return null;
}
